// @need-translate

import {IconType} from '../../../design-system/atoms/Icon/IconType.enum';
import {
  BadgeType,
  ContentHomeBadgeType,
} from '../../../graphql/generated/types';
import {ContentHomeTabItem, ContentHomeTabType} from './type';

export const CONTENT_HOME_STATE_NAME = 'contentHome';

/** 모바일에서 작품요약 정보 컴포넌트(ContentOverview.tsx)의 가로 세로 길이 상수 값입니다.*/
export const CONTENT_OVERVIEW_WIDTH = '100vw';
export const CONTENT_OVERVIEW_WIDTH_IN_TABLET = '50vw';
/** 작품요약 정보 내에 썸네일 가로길이는 작품요약정보 컴포넌트(ContentOverview.tsx)의 46% 크기입니다. */
export const CONTENT_OVERVIEW_THUMBNAIL_HORIZONTAL_PERCENTAGE = '46%';

export const PRODUCT_LIST_ROW_HEIGHT = 92;

export const CONTENT_HOME_MOBILE_TAB_LIST: ContentHomeTabItem[] = [
  {
    text: '첫 화 보기',
    textTKey: 'contenthome_first_ep_tab_button',
    id: ContentHomeTabType.preview,
    isPreview: true,
  },
  {
    text: '회차',
    textTKey: 'contenthome_ep_tab_button',
    id: ContentHomeTabType.product,
  },
  {
    text: '정보',
    textTKey: 'contenthome_info_tab_button',
    id: ContentHomeTabType.about,
  },
  {
    text: '소식',
    textTKey: 'contenthome_notice_tab_button',
    id: ContentHomeTabType.notice,
  },
  {
    text: '댓글',
    textTKey: 'contenthome_comment_tab_button',
    id: ContentHomeTabType.comment,
  },
];

export const CONTENT_HOME_PC_TAB_LIST: ContentHomeTabItem[] = [
  {
    text: '홈',
    textTKey: 'common_tab_home',
    id: ContentHomeTabType.overview,
  },
  {
    text: '정보',
    textTKey: 'contenthome_info_tab_button',
    id: ContentHomeTabType.about,
  },
  {
    text: '소식',
    textTKey: 'contenthome_notice_tab_button',
    id: ContentHomeTabType.notice,
  },
];

export const TAB_TYPE_QUERY_KEY = 'tab_type';

export const CONTENT_HOME_RECOMMEND_SAME_AUTHOR = '작가다른작품추천';
export const CONTENT_HOME_RECOMMEND_SAME_SERIES = '동일작추천';

export const PRODUCT_LIST_WINDOW_SIZE = 25;

export const CONTENT_HOME_TAB_LOGGING_TITLE = {
  [ContentHomeTabType.overview]: '홈탭',
  [ContentHomeTabType.preview]: '첫화보기탭',
  [ContentHomeTabType.product]: '회차탭',
  [ContentHomeTabType.about]: '작품소개탭',
  [ContentHomeTabType.notice]: '소식탭',
  [ContentHomeTabType.comment]: '댓글탭',
};

export const CONTENT_HOME_UPPER_TAB_HEIGHT = 44;
export const SESSION_STORAGE_CONTENT_HOME_AUTO_SCROLL_KEY =
  'content_home_auto_scroll';
export const SESSION_STORAGE_CONTENT_HOME_OPEN_PREVIEW_CALLED_KEY =
  'content_home_open_preview_called';
export const REFRESH_MY_TICKET_EVENT = 'refreshMyticket';
export const REFRESH_CASH_TYPE_HOME = 'refreshCashTypeHome';

export const BADGE_TYPE_TO_CONTENT_HOME_BADGE_TYPE_MAP: {
  [key in BadgeType]?: ContentHomeBadgeType;
} = {
  [BadgeType.BadgeWaitFreeStatic]: ContentHomeBadgeType.BadgeWaitfree,
  [BadgeType.Badge0HourWaitfreeStatic]: ContentHomeBadgeType.Badge0HourWaitfree,
  [BadgeType.Badge1HourWaitfreeStatic]: ContentHomeBadgeType.Badge1HourWaitfree,
  [BadgeType.Badge2HourWaitfreeStatic]: ContentHomeBadgeType.Badge2HourWaitfree,
  [BadgeType.Badge3HourWaitfreeStatic]: ContentHomeBadgeType.Badge3HourWaitfree,
};

export const CONTENT_HOME_WAITFREE_BADGE_TYPE_MAP: {
  [key in ContentHomeBadgeType]?: IconType;
} = {
  [ContentHomeBadgeType.BadgeWaitfree]: IconType.ContentHomeTimeStatic,
  [ContentHomeBadgeType.Badge0HourWaitfree]: IconType.ContentHome0HourStatic,
  [ContentHomeBadgeType.Badge1HourWaitfree]: IconType.ContentHome1HourStatic,
  [ContentHomeBadgeType.Badge2HourWaitfree]: IconType.ContentHome2HourStatic,
  [ContentHomeBadgeType.Badge3HourWaitfree]: IconType.ContentHome3HourStatic,
};
